











import { computed, defineComponent, PropType } from '@vue/composition-api';
import { PaymentQuery } from '@ligo/shared/models';
import BasePage from '../../components/base/BasePage.vue';

export default defineComponent({
  name: 'MolliePayment',
  components: { BasePage },
  props: {
    uuid: {
      type: String,
      required: true
    },
    originUrl: {
      type: String,
      required: true
    },
    query: Object as PropType<PaymentQuery>
  },
  setup(props) {
    const checkoutUrl = computed(() => `${props.originUrl}/checkout/${props.uuid}`);

    function goToMollieCheckout() {
      window.open(checkoutUrl.value, '_blank');
    }
    return {
      checkoutUrl,
      goToMollieCheckout
    };
  }
});
